import React, { FC, ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { selectParentIsAuthenticated } from '../selectors';
import LoginRedirect from './loginRedirect';

interface RequireParentAuthProps {
  children: ReactElement;
}

// The same guard PrivateRoute applies, as a plain wrapper for routes that
// compose other gates around the page (the dashboard runs PreDashboardOffers
// first) and so cannot express the guard as the Route itself.
const RequireParentAuth: FC<RequireParentAuthProps> = ({ children }) => {
  const isAuthenticated = useSelector(selectParentIsAuthenticated);

  return isAuthenticated ? children : <LoginRedirect />;
};

export default RequireParentAuth;
